import { render, staticRenderFns } from "./attachments.vue?vue&type=template&id=68a90cc0&scoped=true"
import script from "./attachments.vue?vue&type=script&lang=js"
export * from "./attachments.vue?vue&type=script&lang=js"
import style0 from "./attachments.vue?vue&type=style&index=0&id=68a90cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a90cc0",
  null
  
)

/* custom blocks */
import block0 from "./attachments.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports